module.exports = __webpack_public_path__ + "static/media/raqeeb.3aa8e498.svg";